/* GA4 route-change tracker.
 *
 * Mounted inside <BrowserRouter> in App.js (this component MUST be a
 * descendant of a Router — hence the separate file instead of inlining
 * inside App). On every `location` change it fires a GA4 `page_view`
 * event. On first mount it also captures utm_* / ref query params into
 * sessionStorage for later attribution.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureUtmParams, trackPageView } from "@/utils/analytics";

export default function AnalyticsTracker() {
  const location = useLocation();

  // Capture UTM once on first mount — subsequent captureUtmParams() calls
  // are cheap no-ops when the URL has no utm_* params.
  useEffect(() => {
    captureUtmParams();
    // Fire the initial pageview immediately; subsequent effect below
    // handles all in-app navigation.
    trackPageView(location.pathname + location.search, document.title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Re-capture on route change too — some campaigns land users on a
    // deep-link URL like /store?utm_source=whatsapp; without this call
    // the initial capture would miss it if the FIRST route was a
    // redirect.
    captureUtmParams();
    trackPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);

  return null;
}
